import { defineMessages } from 'react-intl';

export const startTimeoutMessages = defineMessages({
  title: {
    defaultMessage: "Couldn't start transcribing",
    id: 'l39l0uxrz1',
    description:
      'Toast title when starting a desktop session takes too long and is abandoned',
  },
  description: {
    defaultMessage: 'The session took too long to start. Please try again.',
    id: 'AnK7LTWrL2',
    description:
      'Toast description when starting a desktop session takes too long and is abandoned',
  },
});
